<template>
  <div :class="{ 'd-inline-flex align-middle mr-2': !botaoDropdown }">
    <template v-if="tipoBotao === 'texto'">
      <button
        type="button"
        class="btn btn-sm btn-primary font-weight-bold"
        @click.prevent="abrir"
      >
        <i class="fas fa-users"></i>Usuários
      </button>
    </template>
    <template v-else-if="tipoBotao == 'icone'">
      <b-button
        :variant="variant"
        size="sm"
        class="btn-icon"
        v-b-tooltip.noninteractive
        title="Usuários"
        @click="abrir"
      >
        <i class="fas fa-users"></i>
      </b-button>
    </template>
    <template v-else-if="tipoBotao === 'dropdown'">
      <b-dropdown-item @click.prevent="abrir">Usuários</b-dropdown-item>
    </template>

    <b-modal
      ref="mdlUsuariosConta"
      scrollable
      size="xl"
      ignore-enforce-focus-selector=".swal2-container"
      no-close-on-esc
      no-close-on-backdrop
      content-class="config-modal-content"
      body-class="px-0 pb-2 pt-0"
      header-class="config-modal-header border-0"
      footer-class="config-modal-footer"
    >
      <!-- #modal-title mantém o cabeçalho padrão do b-modal e só acrescenta
      a conta ao lado do título — mesmo padrão dos demais modais. -->
      <template #modal-title>
        Usuários da Conta
        <span v-if="rotuloConta" class="modal-conta-inline ml-2">
          <i class="fas fa-building mr-1"></i>{{ rotuloConta }}
        </span>
      </template>

      <b-tabs
        v-model="abaSelecionada"
        content-class="p-4"
        lazy
        nav-wrapper-class="sticky-top bg-white"
        nav-class="config-tabs-nav"
      >
        <b-tab title="Comunicante" active>
          <tab-usuarios-comunicante
            :conta="conta"
            ref="abaUsuariosComunicante"
            @erro-permissao="fecharPorErro"
          ></tab-usuarios-comunicante>
        </b-tab>

        <b-tab title="Atende" v-if="exibirUsuariosLivechat">
          <tab-usuarios-chat
            :idConta="conta.id"
            ref="abaUsuariosChat"
          ></tab-usuarios-chat>
        </b-tab>

        <b-tab title="CRM" v-if="recursos.includes('CRM')">
          <tab-usuarios-crm
            :idConta="conta.id"
            ref="abaUsuariosCrm"
          ></tab-usuarios-crm>
        </b-tab>
      </b-tabs>

      <template #modal-footer="{ close }">
        <button type="button" class="btn config-btn-secondary" @click="close()">
          Fechar
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import UsuariosComunicante from "./usuario/UsuariosComunicante";
import UsuariosChat from "./livechat/UsuariosChat";
import UsuariosCrm from "./crm/UsuariosCrm";
import ApiService from "@/core/services/api.service";

export default {
  props: {
    conta: Object,
    variant: {
      type: String,
      default: "light-primary"
    },
    tipoBotao: {
      type: String,
      default: "icone"
    }
  },

  data() {
    return {
      abaSelecionada: 0,
      recursos: [],
      existeChatwoot: null
    };
  },

  components: {
    "tab-usuarios-comunicante": UsuariosComunicante,
    "tab-usuarios-chat": UsuariosChat,
    "tab-usuarios-crm": UsuariosCrm
  },

  computed: {
    // Rotulo da conta p/ faixa de identificacao no topo do modal, evitando
    // agir na conta errada quando aberto pela Central de Contas. Login e o
    // fallback principal pois nome as vezes vem vazio (con_nome_identificacao
    // e opcional no backend).
    rotuloConta() {
      const nome = (this.conta?.nome || this.conta?.conNome || "").trim();
      const login = (this.conta?.login || "").trim();

      if (nome && login) return `${nome} (@${login})`;
      if (login) return `@${login}`;
      return nome;
    },

    botaoDropdown() {
      return this.tipoBotao === "dropdown";
    },

    exibirUsuariosLivechat() {
      // existeChatwoot vem do fetch sob demanda (contexto-usuarios); cai no
      // prop da conta quando presente (ex.: tela Contas) como fallback.
      const existe =
        this.existeChatwoot !== null
          ? this.existeChatwoot
          : this.conta.existeContaChatwoot;

      return existe == "S" && this.recursos.includes("LIVE_CHAT");
    }
  },

  methods: {
    async abrir() {
      try {
        // Busca sob demanda o contexto da conta (recursos ativos + se possui
        // Chatwoot), em vez de depender de dados pré-carregados na lista.
        const response = await ApiService.get(
          `conta/contexto-usuarios/${this.conta.id}`
        );
        const dados = response.data.data;

        this.recursos = dados.recursos || [];
        this.existeChatwoot = dados.existeContaChatwoot;

        this.$refs["mdlUsuariosConta"].show();
      } catch {
        // Sem permissão real para essa conta (ex.: fora dos casos previstos
        // pelo gate do botão) — não abre o modal em vez de deixá-lo vazio
        // após o "Não autorizado".
      }
    },

    // Acionado pela aba Comunicante quando a busca de usuários falha (ex.:
    // 403) — fecha o modal em vez de deixá-lo aberto com a lista vazia.
    fecharPorErro() {
      this.$refs["mdlUsuariosConta"].hide();
    }
  }
};
</script>

<style scoped lang="scss"></style>
